import { DefaultFooter } from '@ant-design/pro-components';
import React from 'react';

const Footer: React.FC = () => {
  return (
    <DefaultFooter
      style={{
        background: 'none',
      }}
      copyright={`版权所有 © 2021-${new Date().getFullYear()} 小橘海棠 保留所有权利`}
      links={[
        {
          key: 'beian',
          title: '渝ICP备19010302号',
          href: 'https://beian.miit.gov.cn/',
          blankTarget: true,
        },
      ]}
    />
  );
};

export default Footer;
